export enum scopeToggleState {
  none = 0,
  english,
  translation
}
